<template lang="html">
  <div>

    <!-- Dialog de confirmação do registro (aprovação) do projeto de pesquisa -->
    <c-confirm-dialog v-model="dialogRegistro" @yes="registrarProjeto()" titulo="Confirma o registro do projeto de pesquisa?">
    </c-confirm-dialog>

    <!-- Dialog de confirmação da devolução do projeto de pesquisa para o coordenador -->
    <c-confirm-dialog v-model="dialogDevolucao" @yes="devolverProjeto()" titulo="Confirma a devolução do projeto de pesquisa?">
    </c-confirm-dialog>

    <!-- Dialog de confirmação da conclusão do projeto de pesquisa -->
    <c-confirm-dialog v-model="dialogConclusao" @yes="concluirProjeto()" titulo="Confirma a conclusão do projeto de pesquisa?">
    </c-confirm-dialog>

    <!-- Dialog de confirmação do cancelamento do projeto de pesquisa -->
    <c-confirm-dialog v-model="dialogCancelamento" @yes="cancelarProjeto()" titulo="Confirma o cancelamento do projeto de pesquisa?">
    </c-confirm-dialog>

    <v-toolbar color="white">

      <v-toolbar-title>Barra do administrador</v-toolbar-title>
      <v-spacer></v-spacer>

      <v-toolbar-items class="text-xs-right">

        <!-- Registrar -->
        <c-tooltip-btn
        icon="done_outline"
        color="green"
        :disabled="projeto.situacao.item != 2"
        tooltip="Registrar"
        disabled-tooltip='Apenas um projeto de pesquisa na situação "Aguardando registro" pode ser registrado'
        @click="goRegistrarProjeto()"
        ></c-tooltip-btn>

        <!-- Devolver -->
        <c-tooltip-btn
        icon="not_interested"
        color="red"
        :disabled="projeto.situacao.item != 2"
        tooltip="Devolver para o coordenador"
        disabled-tooltip='Apenas um projeto de pesquisa na situação "Aguardando registro" pode ser devolvido para o coordenador'
        @click="goDevolverProjeto()"
        ></c-tooltip-btn>

        <!-- Concluir -->
        <c-tooltip-btn
        icon="folder"
        color="brown lighten-1"
        :disabled="projeto.situacao.item != 3"
        tooltip="Concluir"
        disabled-tooltip='Apenas um projeto de pesquisa na situação "Em andamento" pode ser concluído'
        @click="goConcluirProjeto()"
        ></c-tooltip-btn>

        <!-- Cancelar -->
        <c-tooltip-btn
        icon="cancel_presentation"
        color="red"
        :disabled="projeto.situacao.item != 3"
        tooltip="Cancelar"
        disabled-tooltip='Apenas um projeto de pesquisa na situação "Em andamento" pode ser cancelado'
        @click="goCancelarProjeto()"
        ></c-tooltip-btn>

      </v-toolbar-items>
    </v-toolbar>


  </div>
</template>

<script>
  import ConfirmDialog from '@/components/c-confirm-dialog'
  import TootipButton from '@/components/c-tooltip-btn'
  import projetos from '@/utils/projetos'
  import { mapGetters, mapActions } from 'vuex'

  export default {
    props: ['projeto', 'extensao'],
    data: () => ({
      dialogRegistro: false,
      dialogDevolucao: false,
      dialogConclusao: false,
      dialogCancelamento: false,
      data: '',
      dataFormatada: '',
      menuData: false
    }),
    computed: {
      ...mapGetters('auth', ['administrador', 'usuarioPROEX'])
    },
    methods: {
      ...mapActions('ui', ['SHOW_GLOBAL_LOADING', 'HIDE_GLOBAL_LOADING', 'SHOW_SNACKBAR']),
      goRegistrarProjeto () {
        this.dialogRegistro = true
      },
      goDevolverProjeto () {
        this.dialogDevolucao = true
      },
      goConcluirProjeto () {
        this.dialogConclusao = true
      },
      goCancelarProjeto () {
        this.dialogCancelamento = true
      },
      // Registrar projeto de pesquisa.
      registrarProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando projeto de pesquisa...' })
        projetos.postRegistrarProjetoPesquisa(this.projeto.id)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Registrando projeto de pesquisa...' })
        })
      },
      // Devolver projeto de pesquisa.
      devolverProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto de pesquisa...' })
        projetos.postDevolverProjetoPesquisa(this.projeto.id)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Devolvendo projeto de pesquisa...' })
        })
      },
      // Concluir projeto de pesquisa.
      concluirProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo projeto de pesquisa...' })
        projetos.postConcluirProjetoPesquisa(this.projeto.id)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Concluindo projeto de pesquisa...' })
        })
      },
      // Cancelar projeto de pesquisa.
      cancelarProjeto: function () {
        this.SHOW_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando projeto de pesquisa...' })
        projetos.postCancelarProjetoPesquisa(this.projeto.id)
        .then(response => {
          this.SHOW_SNACKBAR({snackbarType: 'success', snackbarText: response.body.mensagem})
        })
        .catch(error => {
          console.log('Erro ao mandar o request' + error)
          this.SHOW_SNACKBAR({snackbarType: 'error', snackbarText: error.body.mensagem})
        })
        .finally(() => {
          this.HIDE_GLOBAL_LOADING({ globalLoadingTitle: 'Cancelando projeto de pesquisa...' })
        })
      }
    },
    components: {
      'c-confirm-dialog': ConfirmDialog,
      'c-tooltip-btn': TootipButton
    }
  }
</script>



// WEBPACK FOOTER //
// c-barra-administrador-prppg.vue?205ce0d8